import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { Radio } from '@platform-ui/design-system';
import { DSRadioGroup } from './RadioGroup';
import { ChildElement } from '../utils';
export var DSRadio = /*#__PURE__*/function (_ChildElement) {
  _inherits(DSRadio, _ChildElement);

  var _super = _createSuper(DSRadio);

  function DSRadio() {
    var _this;

    _classCallCheck(this, DSRadio);

    _this = _super.call(this, Radio['__docgenInfo'].props);

    _defineProperty(_assertThisInitialized(_this), "parentName", DSRadioGroup.name);

    _defineProperty(_assertThisInitialized(_this), "component", Radio);

    return _this;
  }

  return DSRadio;
}(ChildElement);

_defineProperty(DSRadio, "_props", ['key'].concat(_toConsumableArray(Object.keys(Radio['__docgenInfo'].props))));
//# sourceMappingURL=Radio.js.map